import { render } from "./UsersUpdater.vue?vue&type=template&id=45862b7e"
import script from "./UsersUpdater.vue?vue&type=script&lang=js"
export * from "./UsersUpdater.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__